import { useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { fileUrl } from "@/lib/api";

export const PhotoGallery = ({ photos }) => {
  const [open, setOpen] = useState(null);
  const go = (d) => setOpen((i) => (i + d + photos.length) % photos.length);
  return (
    <>
      <div className="-mx-4 flex snap-x snap-mandatory gap-2 overflow-x-auto px-4 [scrollbar-width:none]" data-testid="lead-photo-gallery">
        {photos.map((p, i) => (
          <button key={p.path} type="button" onClick={() => setOpen(i)} data-testid={`lead-photo-${i}`}
            className="h-56 w-[78%] shrink-0 snap-start overflow-hidden rounded-2xl bg-slate-200 sm:w-72">
            <img src={fileUrl(p.path)} alt={`Project photo ${i + 1}`} loading="lazy" className="h-full w-full object-cover" />
          </button>
        ))}
      </div>
      <Dialog open={open !== null} onOpenChange={(v) => !v && setOpen(null)}>
        <DialogContent className="max-w-4xl border-0 bg-black p-0" data-testid="lead-photo-lightbox">
          <DialogTitle className="sr-only">Project photo</DialogTitle>
          {open !== null && (
            <div className="relative">
              <img src={fileUrl(photos[open].path)} alt="" className="max-h-[80vh] w-full object-contain" />
              {photos.length > 1 && (
                <>
                  <button type="button" onClick={() => go(-1)} data-testid="lightbox-prev-button" aria-label="Previous photo"
                    className="absolute left-2 top-1/2 flex h-12 w-12 -translate-y-1/2 items-center justify-center rounded-full bg-card/90"><ChevronLeft /></button>
                  <button type="button" onClick={() => go(1)} data-testid="lightbox-next-button" aria-label="Next photo"
                    className="absolute right-2 top-1/2 flex h-12 w-12 -translate-y-1/2 items-center justify-center rounded-full bg-card/90"><ChevronRight /></button>
                </>
              )}
              <p className="absolute bottom-3 left-1/2 -translate-x-1/2 rounded-full bg-black/60 px-3 py-1 text-xs text-white">{open + 1} / {photos.length}</p>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};
